import { Box, Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import BuildCircleOutlinedIcon from "@mui/icons-material/BuildCircleOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";

import { ReportSummary } from "../types";

interface SummaryCardsProps {
  summary: ReportSummary;
}

const SummaryCards = ({ summary }: SummaryCardsProps) => {
  const cards = [
    { label: "Inventory Value", value: `Rs ${summary.inventoryValue.toLocaleString()}`, caption: "Across filtered warehouses", icon: <AccountBalanceWalletOutlinedIcon />, color: "#7c3aed" },
    { label: "Total Stock", value: summary.totalStock, caption: "Spare units in stock", icon: <Inventory2OutlinedIcon />, color: "#2563eb" },
    { label: "Low Stock", value: summary.lowStock, caption: "Items below threshold", icon: <WarningAmberOutlinedIcon />, color: "#d97706" },
    { label: "Purchase Cost", value: `Rs ${summary.purchaseCost.toLocaleString()}`, caption: "Filtered procurement cost", icon: <ShoppingCartOutlinedIcon />, color: "#059669" },
    { label: "Open Tickets", value: summary.openTickets, caption: "Maintenance related", icon: <BuildCircleOutlinedIcon />, color: "#e11d48" },
    { label: "Suppliers", value: summary.suppliers, caption: "Active supplier records", icon: <LocalShippingOutlinedIcon />, color: "#6d28d9" },
  ];

  return (
    <Grid container spacing={2} mb={3}>
      {cards.map(({ label, value, caption, icon, color }) => (
        <Grid item xs={12} sm={6} md={2} key={label}>
          <Card variant="outlined" sx={{ height: "100%", borderColor: `${color}22`, overflow: "hidden", position: "relative", "&:before": { content: '\"\"', position: "absolute", inset: "0 0 auto", height: 3, bgcolor: color } }}>
            <CardContent sx={{ p: 1.75, "&:last-child": { pb: 1.75 } }}>
              <Stack direction="row" spacing={1.25} alignItems="center">
                <Box sx={{ width: 42, height: 42, flexShrink: 0, display: "grid", placeItems: "center", borderRadius: 2, color, bgcolor: `${color}12` }}>{icon}</Box>
                <Box sx={{ minWidth: 0 }}>
                <Typography variant="caption" color="text.secondary" fontWeight={700}>{label}</Typography>
                <Typography variant="h6" fontWeight={850} noWrap>
                  {value}
                </Typography>
                <Typography variant="caption" color="text.secondary" noWrap>{caption}</Typography>
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default SummaryCards;
